import type { FaireProductEntity } from "../../entity_types/product";

export const p_45kc8skjds: FaireProductEntity = {
  token: "p_45kc8skjds",
  type: "product",
  name: "Potassium Iodide",
  brandToken: "b_a3tpqf5bwb",
  brandName: "Double Wood Supplements",
  imageUrl:
    "https://cdn.faire.com/fastly/59a436bfcb380139cfaa816638e2867160c89ae41d52f5010843a120a323bed7.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f392e2eccf0484b0ad70dfb3047d7c9b31d9fa3ee3cccb5b9a787caae42359ba.jpeg",
    "https://cdn.faire.com/fastly/8ae86eb2d4c295f22542816565b53cefdc58d757b79ad33a0e8c5e00c386c656.jpeg",
    "https://cdn.faire.com/fastly/a366e46b420ecdea4b4fbd0cf5891e79b392ab12321d20e54a3f987510e02145.jpeg",
    "https://cdn.faire.com/fastly/bf6011aad82b23dd78b49c6e94d47f2bde00af639fa8c0ebf82ae57001373475.jpeg",
  ],
  priceDollars: 18.01,
  description:
    "Potassium Iodide is a salt made up of the minerals iodine and potassium. Because Potassium Iodide contains nonradioactive iodine it is often used during emergencies resulting in radiation exposure to block radioactive iodine from entering the thyroid gland. The contamination of the thyroid gland with radioactive iodine is a major cause of damage from radiation exposure. Potassium Iodide saturates the thyroid with nonradioactive iodine for roughly 24 hours after use. It should be noted that Potassium Iodine is not a general radioprotective agent and only prevents the thyroid from absorbing radioactive iodine.",
  tags: [],
  msrpDollars: 27.64,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:54:17.194Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
